import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { useIsClient } from 'usehooks-ts';
import { isCurrentPromoActivatedAtom, promoConfigAtom } from '@/atoms/promoAtom';
import { tracker } from '@/utility/tracking/tracker';
export const useTrackPromo = () => {
  const $ = _c(7);
  const promoSlot = useAtomValue(promoConfigAtom);
  const isPromoActivated = useAtomValue(isCurrentPromoActivatedAtom);
  const isClient = useIsClient();
  const voucherCode = promoSlot?.content["promo-tool"].campaignDetails.code;
  let t0;
  let t1;
  if ($[0] !== isClient || $[1] !== isPromoActivated || $[2] !== voucherCode) {
    t0 = () => {
      if (!voucherCode || !isClient) {
        return;
      }
      const status = isPromoActivated ? "active" : "not_active";
      tracker.trackPromo({
        promocode: {
          name: voucherCode,
          status
        }
      });
    };
    t1 = [isPromoActivated, voucherCode, isClient];
    $[0] = isClient;
    $[1] = isPromoActivated;
    $[2] = voucherCode;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== voucherCode) {
    t2 = detail => {
      tracker.trackFeature({
        featureUsed: "content-popup-opened",
        detail,
        promocode: voucherCode
      });
    };
    $[5] = voucherCode;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const trackPopup = t2;
  return trackPopup;
};